<template>
    <v-app id="login-user-ui">
        <v-content login id="create">
            <v-container fluid>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md6>

                        <v-flex xs12>
                            <div class="text-xs-center">
                                <v-img fill-height v-if="this.img_folder"
                                       :src="require('@/assets/clients/'+img_folder+'/logo.png')"
                                       class="my-5 login-logo"
                                       contain
                                       height="120"
                                ></v-img>
                            </div>
                        </v-flex>

                        <v-spacer class="my-2"></v-spacer>

                        <!-- Event Handling - Event Modifiers
												It is a very common need to call event.preventDefault(),
												therefore Vue provides event modifiers for v-on. Recall that modifiers are directive postfixes denoted by a dot. -->
                        <!--mask="###-#########"-->
                        <v-form v-on:submit.prevent="submit" ref="form" v-model="valid" lazy-validation>

                            <!--@modified ana.castro 2019.08.16 SABO-1056-->
                            <v-flex xs12 v-if="this.loginProviderFacebook">
                                <div class="text-xs-center">
                                    <FBLoginButton></FBLoginButton>
                                    <!--                                    <FBLoginButton :params="fbSignInParams"></FBLoginButton>-->
                                </div>
                            </v-flex>
                            <v-spacer class="my-2"></v-spacer>

                            <!--@modified ana.castro 2019.08.27 SABO-1056-->
                            <v-flex xs12 v-if="this.loginProviderGoogle">
                                <div class="text-xs-center">
                                    <GOOGLELoginButton></GOOGLELoginButton>
                                </div>
                            </v-flex>
                            <v-spacer class="my-2"></v-spacer>

                            <!--@modified ana.castro 2019.08.22 SABO-1056-->
                            <v-flex xs12 v-if="this.loginProviderInstagram">
                                <div class="text-xs-center">
                                    <IGLoginButton></IGLoginButton>
                                </div>
                            </v-flex>

                            <v-spacer class="my-4"></v-spacer>

                            <div class="login-title1">
                                <v-spacer class="my-2 login-title1-spacer"></v-spacer>

                                <v-flex xs12>
                                    <h2>{{ $vuetify.t('$vuetify.authentication.login_step_user_title') }}</h2>
                                </v-flex>
                            </div>

                            <v-spacer class="my-2 login-user-spacer"></v-spacer>

                            <v-flex xs12>
                                <VuePhoneNumberInput :dark="dark_theme" v-model="username"
                                                     :default-country-code="countryCode"
                                                     :preferred-countries="preferredCountryCodes"
                                                     required
                                                     :error="valid===false"
                                                     :translations="{
                                                      countrySelectorLabel: this.$vuetify.t('$vuetify.help_country_code'),
                                                      phoneNumberLabel: this.$vuetify.t('$vuetify.help_mobile_number'),
                                                      example: this.$vuetify.t('$vuetify.help_example')}"
                                                     @update="define_selected_country_code"
                                />
                            </v-flex>

                            <v-spacer class="my-2"></v-spacer>

                            <v-flex xs12 v-if="action_type_login">
                                <v-text-field
                                        class="password"
                                        :append-icon="e1 ? 'fal fa-eye' : 'fal fa-eye-slash'"
                                        @click:append="() => (e1 = !e1)"
                                        name="password"
                                        v-bind:label="$vuetify.t('$vuetify.authentication.password')"
                                        v-model="password"
                                        :type="e1 ? 'password' : 'text'"
                                        :rules="passwordRules"
                                        required
                                        :counter=false
                                ></v-text-field>
                                <v-btn :disabled="!valid"
                                       @click="submitPasswordRecover"
                                       flat small
                                       color="primary"
                                       style="padding: 0;margin-top: -15px;margin-left: 0px;font-size: 12px;"
                                >
                                    {{ $vuetify.t('$vuetify.authentication.password_recover') }}
                                </v-btn>
                            </v-flex>

                            <v-flex xs12>
                                <div class="text-xs-center">
                                    <v-btn v-if="action_type_login"
                                           :disabled="!valid"
                                           @click="submit"
                                           color="primary"
                                           large
                                    >
                                        {{ $vuetify.t('$vuetify.next') }}
                                        <v-icon right small>fal fa-angle-double-right</v-icon>
                                    </v-btn>

                                    <!--
                                    <v-btn v-if="show_pwd_recover"
                                           :disabled="!valid"
                                           @click="submitPasswordRecover"
                                           outline
                                           color="primary"
                                    >
                                        {{ $vuetify.t('$vuetify.authentication.password_recover') }}
                                    </v-btn>
                                    -->
                                </div>
                            </v-flex>
                            <!-- TODO Traduzir Isto!-->
                            <v-spacer class="my-5"></v-spacer>
                            <v-flex xs12>
                                <div class="text-xs-center">
                                    <p class="headline font-weight-regular">Novo Utilizador?</p>
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                <div class="text-xs-center">
                                    <v-btn v-if="action_type_login"
                                           @click="newRegister"
                                           color="primary"
                                           large
                                    >
                                        Registar Agora
                                        <v-icon right small>fal fa-angle-double-right</v-icon>
                                    </v-btn>


                                </div>
                            </v-flex>

                            <!-- @modified ana.castro 2019.12.03 The Login interface must display a link to access the Terms and Conditions-->
                            <v-spacer class="my-3"></v-spacer>
                            <v-flex xs12>
                                <div class="text-xs-center">
                                    <p class="subheading font-weight-regular" @click="goToTermsPolicy"><a
                                            style="color: inherit;">{{
                                            $vuetify.t('$vuetify.gdpr_agreement.terms_policy')
                                        }}</a></p>
                                </div>
                            </v-flex>

                            <v-spacer class="my-2"></v-spacer>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-container>

            <!--            <v-speed-dial-->
            <!--                    v-model="fab"-->
            <!--                    :right="right"-->
            <!--                    :bottom="bottom"-->
            <!--                    :direction="direction"-->
            <!--                    :open-on-hover="hover"-->
            <!--                    :transition="transition"-->
            <!--            >-->
            <!--                <template v-slot:activator>-->
            <!--                    <v-btn-->
            <!--                            v-model="fab"-->
            <!--                            color=primary-->
            <!--                            dark-->
            <!--                            fab-->
            <!--                    >-->
            <!--                        <v-icon>fal fa-plus</v-icon>-->
            <!--                        <v-icon>fal fa-times-circle</v-icon>-->
            <!--                    </v-btn>-->
            <!--                </template>-->
            <!--                <v-btn v-if="action_type_login"-->
            <!--                       fab-->
            <!--                       dark-->
            <!--                       small-->
            <!--                       color="#75787B"-->
            <!--                       @click="activatePasswordRecoverAction"-->
            <!--                >-->
            <!--                    <v-icon>fal fa-key</v-icon>-->
            <!--                </v-btn>-->
            <!--                <v-btn v-if="!action_type_login"-->
            <!--                       fab-->
            <!--                       dark-->
            <!--                       small-->
            <!--                       color="#75787B"-->
            <!--                       @click="activateLogInAction"-->
            <!--                >-->
            <!--                    <v-icon>fal fa-sign-in</v-icon>-->
            <!--                </v-btn>-->
            <!--                <v-btn-->
            <!--                        fab-->
            <!--                        dark-->
            <!--                        small-->
            <!--                        color="#75787B"-->
            <!--                        @click="newRegister"-->
            <!--                >-->
            <!--                    <v-icon>fal fa-user-plus</v-icon>-->
            <!--                </v-btn>-->
            <!--            </v-speed-dial>-->

        </v-content>
    </v-app>
</template>

<script>
import {mapGetters} from "vuex";
import {getErrorMessage, recaptchaHelper} from "@/_helpers";
import FBLoginButton from "@/components/sociallogin/FBLoginButton.vue";
import IGLoginButton from "@/components/sociallogin/IGLoginButton.vue";
import GOOGLELoginButton from "@/components/sociallogin/GOOGLELoginButton.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
//TODO mover isto para block css
import "clientEntryLayout"
import {userService} from "@/_services";

export default {
    data() {
        return {
            action_type_login: true,
            show_pwd_recover: false,
            dark_theme: true,
            selected_country_code: null,
            img_folder: "",
            status: '',
            username: '',
            password: '',
            submitted: false,
            valid: false,
            e1: true,
            //Configurations for the speed-dial
            direction: 'top',
            fab: false,
            hover: false,
            right: true,
            bottom: true,
            transition: 'slide-y-reverse-transition'
            //End of speed-dial
        }
    },
    components: {FBLoginButton, IGLoginButton, GOOGLELoginButton, VuePhoneNumberInput},
    methods: {
        submit() {
            if (this.$refs.form.validate() && this.username && this.password) {

                // 1 - setting the Loading Layer
                this.$store.dispatch("loader/setLoading", true);

                // 2 - defining variables with both username and password values
                let password = this.password;
                let username = this.selected_country_code + '-' + this.username.split(' ').join('');

                // 3 - Once both the username and the password are defined,
                //  it is possible to use the authentication module: the login action is called;
                //  this login action uses the userService's function login which uses the Axios library to fetch data in a async mode (using promises)
                //  to get the API token which will enable the user to be recognized by a match between the user and the received Token
                const {dispatch} = this.$store;
                if (username && password) {
                    recaptchaHelper('login', this).then((token) => {
                            dispatch('authentication/login', {username, password, token});
                            this.show_pwd_recover = true
                        },
                        error => {

                            getErrorMessage(error, 'Login User Recaptcha', this);
                        });
                } else {
                    getErrorMessage(null, 'User or Password not supplied!', this);
                }
            }
        },
        submitPasswordRecover() {
            if (this.username) {
                // 1 - setting the Loading Layer
                this.$store.dispatch("loader/setLoading", true);

                this.$log.debug("Before Get New Password for User = " + this.username);

                let obj = {
                    "username": this.selected_country_code + '-' + this.username.split(' ').join('')
                };

                recaptchaHelper('getNewPassword', this).then((token) => {
                        obj.recaptcha_token = token;
                        // eslint-disable-next-line
                        userService.getNewPassword(obj).then(result => {
                                this.$log.debug("Get New Password | Received User Status = " + result.status);
                                this.$store.dispatch("loader/setLoading", false);
                                this.$store.dispatch("alert/success", this.$vuetify.t('$vuetify.authentication.password_new_success_sent'));
                                this.action_type_login = true;
                            },
                            error => {
                                getErrorMessage(error, 'Get New Password', this);
                            });
                    },
                    error => {
                        getErrorMessage(error, 'Get New Password Recaptcha', this);
                    });
            } else {
                this.$store.dispatch("alert/error", "É necessário indicar o Nr. Telemóvel");
            }
        },
        /**
         * Ativar a funcionalidade de Recuperação de Password
         *
         **/
        activatePasswordRecoverAction() {
            this.action_type_login = false;
        },
        /**
         * Ativar a funcionalidade de Login
         *
         **/
        activateLogInAction() {
            this.action_type_login = true;
        },
        newRegister() {
            this.$router.push({
                name: 'user-register',

            });
        },
        //@modified ana.castro 2019.12.03 The Login interface must display a link to access the Terms and Conditions
        goToTermsPolicy() {
            this.$router.push({name: "terms-policy"});
        },
        // onSocialSignInError(error) {
        //     this.$log.debug("Social Sign In Error | User cancelled login or did not fully authorize", error);
        // }

        // @modified ana.castro 2020.05.12 SCLAPP-28 The Country Code should be appended to the Phone Number
        /**
         *
         * @param payload
         */
        define_selected_country_code(payload) {
            //Payload Example
            // {
            // 	"countryCode": "FR",
            // 	"isValid": true,
            // 	"phoneNumber": "0665656565",
            // 	"countryCallingCode": "33",
            // 	"formattedNumber": "+33665656565",
            // 	"nationalNumber": "665656565",
            // 	"formatInternational": "+33 6 65 65 65 65",
            // 	"formatNational": "06 65 65 65 65",
            // 	"uri": "tel:+33665656565",
            // 	"e164": "+33665656565"
            // }
            this.selected_country_code = payload.countryCallingCode;
            // modified @daniel.silva 2020.07.05 onl
            this.valid = payload.isValid
        }
    },
    computed: {
        // Defining the Username field as being mandatory;
        usernameRules: function () {
            let re = /^9[0-9]{8}$/;
            return [
                v => !!v || this.$vuetify.t('$vuetify.phone_number'),
                v => (v && v.length === 9) || this.$vuetify.t('$vuetify.authentication.username_nine_digits'),
                v => (v && re.test(v)) || this.$vuetify.t('$vuetify.authentication.phone_number_invalid')
            ]
        },
        // Defining the Password field as being mandatory;
        //  TODO: !!! Note: I don't know why I have to do this, once I have the field declared as REQUIRED
        passwordRules: function () {
            return [
                v => !!v || this.$vuetify.t('$vuetify.authentication.password_required'),
            ]
        },
        ...mapGetters({
            loginProviderFacebook: 'configs/loginProviderFacebook',
            loginProviderInstagram: 'configs/loginProviderInstagram',
            loginProviderGoogle: 'configs/loginProviderGoogle',
            // @modified ana.castro 2020.05.12 SCLAPP-28 The Country Code should be appended to the Phone Number
            countryCode: 'configs/countryCode',
            preferredCountryCodes: 'configs/preferredCountryCodes',
        })

    },
    created() {
        this.$store.dispatch('authentication/logout');
    },

    mounted() {
        this.img_folder = process.env.VUE_APP_ASSETS_FOLDER;
        this.dark_theme = process.env.VUE_APP_VUETIFY_DARK_THEME === "True";
    },
}
</script>

<style lang="stylus">
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}

/*.application*/
/*  background: #15191c url(../../assets/background.jpg) repeat-y 0 0 !important*/

/****************************************** START WOWFOODS ***********************************************************/

/****************************************** END WOWFOODS *************************************************************/

/****************************************** START CACULA/DEGEMA *************************************************************/
/*#login-user-ui
    .v-responsive.v-image.my-5
        height: 300px !important;
*/
/****************************************** END CACULA/DEGEMA *************************************************************/

/****************************************** START NAZ *************************************************************/
/*
#login-user-ui
  background: #EC0501 !important

  .login-logo
    margin-top: 10px !important;
    margin-bottom: 20px !important;

  .theme--dark.v-label
    color: #FFFFFF !important

  .theme--dark.v-input:not(.v-input--is-disabled) input
    color: #fff !important
    caret-color: #fff !important

  .error--text
    color: #fd0 !important
    caret-color: #fd0 !important

  .theme--dark.v-icon.error--text
    color: #fd0 !important

  .theme--dark.v-icon
    color: #FFFFFF !important

  .v-text-field > .v-input__control > .v-input__slot:after,
  .v-text-field > .v-input__control > .v-input__slot:after
    border-color: #fff !important

  .v-responsive.v-image.my-5
    height: 300px !important

  .theme--dark.v-text-field > .v-input__control > .v-input__slot::before
    border-color: #fff !important

  .fa-angle-double-right::before
    content: "\f105"

  .login-title2,
  .login-user-spacer,
  .login-title2-spacer
    display: none

  .login-title1 h2
    font-size: 16px
    color: #ffffff

  .v-btn.primary
    background-color: #fff !important

  .v-btn.primary .v-btn__content,
  .v-btn.primary .v-icon
    color: #EC0501 !important

  // FONT SIZES CONFIG

  .v-btn
    font-size: 18px !important;

  .v-input,
  .v-label
    font-size 18px

  .input-tel__input
    color: black
*/

/******************************************** END NAZ *************************************************************/

</style>
